import {
  TOGGLE_TUTORIAL,
  TOGGLE_TUTORIAL_START_DIALOG,
  SET_CURRENT_TUTORIAL_STEP,
  TOGGLE_TUTORIAL_CONFIRMATION_DIALOG,
} from '../lib/types';

const initialState = {
  toggleTutorial: false,
  currentTutorialStep: 0,
  toggleTutorialStartDialog: false,
  toggleTutorialConfirmationDialog: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case TOGGLE_TUTORIAL:
      return {
        ...state,
        toggleTutorial: action.payload,
      };

    case TOGGLE_TUTORIAL_START_DIALOG:
      return {
        ...state,
        toggleTutorialStartDialog: action.payload,
      };

    case TOGGLE_TUTORIAL_CONFIRMATION_DIALOG:
      return {
        ...state,
        toggleTutorialConfirmationDialog: action.payload,
      };

    case SET_CURRENT_TUTORIAL_STEP:
      return {
        ...state,
        currentTutorialStep: action.payload,
      };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/tutorial-reducer.js